import useDebounceInput from 'customHooks/useDebounceInput'
import {
  setCheckAll,
  setUncheckAll,
  fetchGetSOProduct,
} from 'features/SupplyOrder/redux/outboundSOAddProduct'
import { useMemo } from 'react'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'

const useTable = () => {
  const dispatch = useAppDispatch()

  const { locationId, query, checkedIds, createSO, data } = useAppSelector(
    (state) => state.outboundSOAddProduct,
    shallowEqual,
  )

  const currentPageIds = useMemo(() => data.map((item) => item.productUniqueKey), [data])

  const checkedCount = currentPageIds.filter((id) => checkedIds.includes(id)).length
  const isAllChecked = checkedCount === currentPageIds.length && currentPageIds.length > 0
  const isIndeterminate = checkedCount > 0 && checkedCount < currentPageIds.length

  const isSOReturnType = createSO?.soType.toLowerCase() === 'return'

  const locationSelected = {
    origin: createSO?.origin?.location_name || null,
    destination: isSOReturnType
      ? createSO?.poReff?.vendorName || null
      : createSO?.destination?.location_name || null,
  }

  const [search, handleSearch] = useDebounceInput({
    onChange: (value) => {
      dispatch(
        fetchGetSOProduct({
          locationId,
          params: {
            name: value,
            pageIndex: 0,
          },
        }),
      )
    },
  })

  const handleChangeCheckbox = (checked: boolean) => {
    if (checked) {
      dispatch(setCheckAll(currentPageIds))
    } else {
      dispatch(setUncheckAll(currentPageIds))
    }
  }

  const handleChangePage = (page: number) => {
    dispatch(
      fetchGetSOProduct({
        locationId,
        params: {
          pageIndex: page - 1,
        },
      }),
    )
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    dispatch(
      fetchGetSOProduct({
        locationId,
        params: {
          pageSize: rowsPerPage,
          pageIndex: 0,
        },
      }),
    )
  }

  return {
    isAllChecked,
    isIndeterminate,
    checkedIds,
    query,
    locationSelected,
    data,
    search,
    handleSearch,
    handleChangeCheckbox,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTable
